<template>
  <div class="applications-container">
    <div class="component-title">
      <div class="component-title">
        <h1 class="">Financial Assets</h1>
      </div>
    </div>

    <div>
      <form id="form10" autocomplete="off" class="mt-40">
        <div class="container w-100" style="font-size: 18px">

          <div v-for="newContent in temp" :key="newContent.id">
            <div class="assets-container mb-20">
              <div class="col-sm-6 col-md-6">
                <span>Asset Type</span>
                <select v-model="newContent.selected">
                  <option value="" disabled>Select Property</option>
                  <option v-for="(option, index) in options" :key="index" v-bind:value="option.value">{{ option.label }}</option>
                </select>
              </div>

              <div class="assets-content">

                <div v-if="newContent.selected == 'Owner occipier property' || newContent.selected == 'Investment property address'">
                  <div class="col-sm-6 col-md-6 float-right">
                    <span>Property Type</span>
                    <select>
                      <option selected="selected" value="">Select</option>
                    </select>
                  </div>
                  <div class="clear"></div>

                  <div class="address-container mt-10 pl-15 pr-15">

                    <div class="row pt-10">
                      <div class="col-sm-12 col-md-12">
                        <span>Enter your current address</span>
                        <input type="text" class="input-common-lg w-100" />
                      </div>
                    </div>

                    <p class="pt-10">
                      Can't find your address?
                      <span style="color: green; cursor: pointer" onclick="$(this).closest('.address-container').find('.address-expand').toggleClass('none')">Click here</span>
                    </p>

                    <div class="address-expand none">
                      <div>
                        <div class="row">
                          <div class="col-sm-6 col-md-6">
                            <span>Unit Number</span>
                            <input type="text" class="input-common-lg w-100" />
                          </div>
                          <div class="col-sm-6 col-md-6">
                            <span>Street Number</span>
                            <input type="text" class="input-common-lg w-100" />
                          </div>
                        </div>

                        <div class="row pt-10">
                          <div class="col-sm-6 col-md-6">
                            <span>Street Name</span>
                            <input type="text" class="input-common-lg w-100" />
                          </div>
                          <div class="col-sm-6 col-md-6">
                            <span>City/Suburb</span>
                            <input type="text" class="input-common-lg w-100" />
                          </div>
                        </div>

                        <div class="row pt-10">
                          <div class="col-sm-6 col-md-6">
                            <span>State</span>
                            <input type="text" class="input-common-lg w-100" />
                          </div>
                          <div class="col-sm-6 col-md-6">
                            <span>Postcode</span>
                            <input type="text" class="input-common-lg w-100" />
                          </div>
                        </div>
                      </div>

                      <div>
                        <div class="row pt-10">
                          <div class="col-sm-6 col-md-6">
                            <span>Country</span>
                            <input type="text" class="input-common-lg w-100" />
                          </div>
                          <div class="col-sm-6 col-md-6">
                            <span>Zoning</span>
                            <select>
                              <option selected="selected" value="">Select</option>
                              <option value="Commercial">Commercial</option>
                              <option value="Residential">Residential</option>
                              <option value="Industrial">Industrial</option>
                              <option value="Rural">Rural</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <div>
                        <div class="row pt-10">
                          <div class="col-sm-6 col-md-6">
                            <span>Ownership %</span>
                            <input type="text" class="input-common-lg w-100" />
                          </div>
                          <div class="col-sm-6 col-md-6 pt-10 pb-10">
                            <p>
                              <label>
                                <input type="checkbox" class=""> To be sold?
                              </label>
                            </p>
                            <p>
                              <label for="">
                                <input type="checkbox" class=""> Will become Investment after settlement?
                              </label>
                            </p>
                          </div>
                        </div>
                      </div>

                    </div>

                  </div>

                </div>
                <!-- END property opt -->

                <div v-if="newContent.selected == 'Vehicle make and model'">
                  <div class="col-sm-6 col-md-6 float-right">
                    <span>Vehicle Type</span>
                    <select required="">
                      <option selected="selected" value="">Select</option>
                    </select>
                  </div>
                  <div class="clear"></div>
                  
                  <div class="mt-10 pl-15 pr-15">
                    <div class="row pt-10">
                      <div class="col-sm-12 col-md-12">
                        <span>Enter Vehicle Make and Model</span>
                        <input type="text" class="input-common-lg w-100"/>
                      </div>
                    </div>
                    <div class="row pt-10">
                      <div class="col-sm-6 col-md-6">
                        <span>Estimated Compliance Date</span>
                        <input type="date" class="input-common-lg w-100"/>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- END Vehicle opt -->

                <div v-if="newContent.selected == 'Bank Account'">
                  <div class="col-sm-6 col-md-6 float-right">
                    <span>Account Type</span>
                    <select required="">
                      <option selected="selected" value="">Select</option>
                      <option value="Savings">Savings</option>
                      <option value="Cheque">Cheque</option>
                      <option value="Transaction">Transaction</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                  <div class="clear"></div>
                  
                  <div class="mt-10 pl-15 pr-15">
                    <div class="row pt-10">
                      <div class="col-sm-6 col-md-6">
                        <span>Bank Name</span>
                        <input type="text" class="input-common-lg w-100" />
                      </div>
                      <div class="col-sm-6 col-md-6">
                        <span>Bank Account Name</span>
                        <input type="text" class="input-common-lg w-100" />
                      </div>
                    </div>
                    <div class="row pt-10">
                      <div class="col-sm-6 col-md-6">
                        <span>Account BSB</span>
                        <input type="text" class="input-common-lg w-100" />
                      </div>
                      <div class="col-sm-6 col-md-6">
                        <span>Account Number</span>
                        <input type="text" class="input-common-lg w-100" />
                      </div>
                    </div>
                    <div class="row pt-10">
                      <div class="col-sm-6 col-md-6">
                        <span>Value</span>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text">$</span>
                          </div>
                          <input type="text" class="form-control input-common-lg">
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-6">
                        <span>Ownership</span>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text">%</span>
                          </div>
                          <input type="text" class="form-control input-common-lg">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- END Bank opt -->

                <div v-if="newContent.selected == 'Home contents' || newContent.selected == 'Shares' || newContent.selected == 'Other'">
                  <div class="col-sm-6 col-md-6 float-right">
                    <span>{{newContent.selected}}</span>
                    <input class="input-common-lg w-100" type="text"/>
                  </div>
                  <div class="clear"></div>
                  
                  <div class="mt-10 pl-15 pr-15">
                    <div class="row pt-10">
                      <div class="col-sm-6 col-md-6">
                        <span>Value</span>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text">$</span>
                          </div>
                          <input type="text" class="form-control input-common-lg">
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-6">
                        <span>Ownership</span>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text">%</span>
                          </div>
                          <input type="text" class="form-control input-common-lg">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- END Home | Shares | Other opt -->

                <div v-if="newContent.selected == 'Super fund institution'">
                  <div class="col-sm-6 col-md-6 float-right">
                    <span>{{newContent.selected}}</span>
                    <input class="input-common-lg w-100" type="text"/>
                  </div>
                  <div class="clear"></div>
                  
                  <div class="mt-10 pl-15 pr-15">
                    <div class="row pt-10">
                      <div class="col-sm-6 col-md-6">
                        <span>Membership Number</span>
                        <input type="text" class="input-common-lg w-100">
                      </div>
                      <div class="col-sm-6 col-md-6">
                        <span>Ownership</span>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text">%</span>
                          </div>
                          <input type="text" class="form-control input-common-lg">
                        </div>
                      </div>
                    </div>
                    <div class="row pt-10">
                      <div class="col-sm-6 col-md-6">
                        <span>Value</span>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text">$</span>
                          </div>
                          <input type="text" class="form-control input-common-lg">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- END Super fund opt -->

              </div>

              <div class="clear"></div>

              <div v-if="newContent.id!=0" class="flx pointer change-employment-btn pt-10" style="width: max-content" @click="removeAsset($event, newContent.id)">
                <div class="reduce-icon">-</div>
                <div>Remove Security</div>
              </div>

            </div>
          </div>


          <div class="clear">
            <div class="flx pointer change-employment-btn pt-10 addEmploymentBtn" style="width: max-content" @click="addAsset()" >
              <div class="add-icon">+</div>
              <span>Add New Security</span>
            </div> 
          </div>

        </div>
      </form>
    </div>
    
    <div class="flx loan-container mt-60">
        <a type="button" class="continue-btn continue-btn-small steps-btn"
            href="#" @click.prevent="onContinue('financial-capacity-2')">BACK</a>
        <a type="button"
            class="continue-btn continue-btn-small continue-btn-small-right steps-btn"
            href="#" @click.prevent="onContinue('financial-liabilities')">CONTINUE</a>
    </div>
    <div class="mt-60 clear"></div>
    
  </div>
</template>

<script>
export default {
  props: ["onChangeStep"],
  data(){
    return {
      id: 0,
      options: [
        {value:"Owner occipier property",label:"Owner occipier property"},
        {value:"Investment property address",label:"Investment property address"},
        {value:"Vehicle make and model",label:"Vehicle make and model"},
        {value:"Bank Account",label:"Bank Account"},
        {value:"Home contents",label:"Home contents"},
        {value:"Shares",label:"Shares"},
        {value:"Other",label:"Other"},
        {value:"Super fund institution",label:"Super fund institution"},], 
      temp: [{id: 0,selected:""}],}
  },
  methods: {
    onContinue(step) {
      this.onChangeStep(step);
    },
    addAsset(){
      var new_id = 0;
      do{++new_id;}while(this.temp.find(e => e.id === new_id));
      this.temp.push({
        id: new_id
      })
    },
    removeAsset(event, id){
      var index = this.temp.map(object => object.id).indexOf(id);
      this.temp.splice(index,1);
    },
  },
};
</script>
